import { render, staticRenderFns } from "./TheStory.vue?vue&type=template&id=1911158e&"
import script from "./TheStory.vue?vue&type=script&lang=js&"
export * from "./TheStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports